export default __webpack_public_path__ + "static/media/Fairy-01.e45fccaa.png";